import { useCallback, useEffect, useMemo, useState } from "react";
import api from "../../lib/api";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";
import ExpenseFormDialog from "./ExpenseFormDialog";
import ExpenseList from "./ExpenseList";

export default function ExpenseEntryOnly() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState({ defaults: [], custom: [] });
  const [open, setOpen] = useState(false);

  const load = useCallback(() => api.get("/expenses").then((r) => setItems(r.data)), []);
  const loadCats = useCallback(() => api.get("/expense-categories").then((r) => setCats(r.data)), []);
  useEffect(() => { load(); loadCats(); }, [load, loadCats]);
  const categories = useMemo(() => [...cats.defaults, ...cats.custom.map((c) => c.name)], [cats]);

  return (
    <div className="space-y-5" data-testid="expenses-entry-only">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#1B4D3E]">Muhasebe</div>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900">Gider Girişi</h1>
        </div>
        <Button className="bg-rose-600 hover:bg-rose-700 text-white gap-2" onClick={() => setOpen(true)} data-testid="add-expense-btn"><Plus size={16} /> Gider Ekle</Button>
      </div>
      <div className="text-sm font-semibold text-slate-700">Girdiğim Giderler <span className="text-slate-400 font-normal">({items.length})</span></div>
      <div className="text-xs text-slate-500 -mt-3">Yanlış bir giriş fark ederseniz düzeltme için yöneticinize başvurun.</div>
      <ExpenseList items={items} readOnly />
      <ExpenseFormDialog open={open} onOpenChange={setOpen} editing={null} categories={categories} onCategoriesChanged={loadCats} onSaved={load} canManage={false} />
    </div>
  );
}
